import React from 'react';
import ReactDOM from 'react-dom';
import { Parser } from 'html-to-react';
import { windowsResourceUpdate } from './resources';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import packageJson from '../../package.json';

Sentry.init({
    dsn:
        'https://83c445b4c7214ef18797c7984adf627c@o1169223.ingest.sentry.io/6458402',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    /*  replaysSessionSampleRate: 0.1, */
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    /* replaysOnErrorSampleRate: 1.0, */
    ignoreErrors: [
        // Other marketing stuffs: Taboola,
        "reading 'isCookieBannerOpen'",
        "evaluating 't.isCookieBannerOpen'",
        // FB & FB pixel
        'fb_xd_fragment',
        "Can't find variable: fbq",
        'fbq is not defined',
        // Google tag manager
        '_tfa is not defined',
        'Can\'t find variable: _tfa',
        'Cannot read properties of null (reading \'parentNode\')',
        'undefined is not an object (evaluating \'a.M\')',
        'undefined is not an object (evaluating \'a.L\')',
        'undefined is not an object (evaluating \'b.container[a]\')',
        'getRestrictions',
    ],
    denyUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        // Google things,
        // https://googleads.g.doubleclick.net/pagead/viewthroughconversion/842540967/....
        /googleads\.g\.doubleclick\.net\/pagead\/viewthroughconversion/i,
        // https://pagead2.googlesyndication.com/pagead/buyside_topics/set/
        /pagead2\.googlesyndication\.com\/pagead\/buyside_topics\/set/i,
        // Other plugins
        /cdn\.taboola\.com/i,
    ],
    integrations: [
        new BrowserTracing() /*  new Sentry.Replay({
        networkDetailAllowUrls: [''],
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
    }) */,
    ],
    tracesSampleRate: 0, // transaction sampling
    sampleRate: 0.5, // error sampling
    release: packageJson.version,
    environment: process.env.NODE_ENV,
});

const components = [];

const parser = new Parser();

const mountNode = (node) => {
    components[node.dataset.react](node);
};

const unmountNode = (node) => {
    ReactDOM.unmountComponentAtNode(node);
};

const observer = new MutationObserver(function (mutationList) {
    const removed = mutationList.map((record) => record.removedNodes);
    removed.forEach((nodeList) => {
        nodeList.forEach((node) => {
            if (node.querySelectorAll) {
                const reactChildren = node.querySelectorAll('[data-react]');
                reactChildren.forEach((reactNode) => unmountNode(reactNode));
            }
            if (
                node.dataset &&
                node.dataset.react &&
                components[node.dataset.react]
            ) {
                unmountNode(node);
            }
        });
    });

    const added = mutationList.map((record) => record.addedNodes);
    added.forEach((nodeList) => {
        nodeList.forEach((node) => {
            if (node.querySelectorAll) {
                const reactChildren = node.querySelectorAll('[data-react]');
                reactChildren.forEach((reactNode) => mountNode(reactNode));
            }
            if (
                node.dataset &&
                node.dataset.react &&
                components[node.dataset.react]
            ) {
                mountNode(node);
            }
        });
    });
});

observer.observe(document, {
    attributes: true,
    childList: true,
    subtree: true,
});

function registerComponent(name, Component) {
    function mount(node) {
        node.setAttribute('data-react-initialized', true);
        const props = Object.assign({}, node.dataset);
        Object.keys(props).forEach((key) => {
            try {
                if (props[key] === 'True') {
                    props[key] = true;
                } else if (props[key] === 'False') {
                    props[key] = false;
                } else {
                    props[key] = JSON.parse(props[key]);
                }
            } catch (e) {}
            try {
                if (key == 'stringResources') {
                    windowsResourceUpdate(props[key]);
                }
            } catch (e) {}
        });

        let children = props.textChildren
            ? node.innerHTML
            : parser.parse(node.innerHTML) || [];

        if (children.filter) {
            children = children.filter((child) => typeof child === typeof {});
        }

        ReactDOM.render(<Component {...props}>{children}</Component>, node);
    }

    const nodes = document.querySelectorAll('[data-react="' + name + '"]');
    nodes.forEach(mount);

    components[name] = mount;
}

function registerComponents(components) {
    Object.keys(components).forEach((name) =>
        registerComponent(name, components[name]),
    );
}

export default registerComponents;
